import React from "react";
import {cn} from "../utils";

const PieChartIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
         height="512"
         width="512"
         viewBox="0 0 24 24"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg">
        <g clipRule="evenodd"
           fill={color || "currentColor"}
           fillRule="evenodd">
            <path
                d="m11.25 4.00025c0-1.46693 1.235-2.87052 2.8855-2.53775 4.2245.85178 7.5505 4.17774 8.4023 8.40229.3327 1.65041-1.0709 2.88551-2.5378 2.88551h-6c-1.5188 0-2.75-1.2313-2.75-2.75zm2.589-1.06734c-.5151-.10386-1.089.32514-1.089 1.06734v6.00005c0 .6903.5596 1.25 1.25 1.25h6c.7422 0 1.1712-.5739 1.0673-1.089-.7324-3.63266-3.5957-6.49596-7.2283-7.22839z"/>
            <path
                d="m9.73141 4.05686c.09166.40394-.1615.80571-.56544.89737-3.67387.83364-6.41597 4.12028-6.41597 8.04557 0 4.5564 3.69365 8.25 8.25 8.25 3.9253 0 7.2119-2.7421 8.0456-6.416.0916-.4039.4934-.6571.8973-.5654.404.0917.6571.4934.5655.8974-.9853 4.3421-4.8673 7.584-9.5084 7.584-5.38478 0-9.75-4.3652-9.75-9.75 0-4.64105 3.24195-8.52311 7.58403-9.50839.40395-.09166.80572.1615.89738.56545z"/>
        </g>
    </svg>
);

export {PieChartIcon};